// /forms-preview is a dev-only page: reachable only on the preview/dev hosts
// (or a local build with REACT_APP_FORMS_PREVIEW=1), and only after sign-in
// (the route is not in unrestrictedRoutes). It is linked from nowhere.
export const FORMS_PREVIEW_HOSTS = ["hub.preview.brainymed.com", "devcare.brainymed.com", "localhost", "127.0.0.1"];

export function formsPreviewAllowed(loc = typeof window !== "undefined" ? window.location : null, env = process.env) {
  if (env && env.REACT_APP_FORMS_PREVIEW === "1") return true;
  return !!loc && FORMS_PREVIEW_HOSTS.includes(loc.hostname);
}
